import useToggle from '@/common/hooks/useToggle';
import classes from '@/components/Category/category-description-element.module.css';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import { useEffect } from 'react';

const Description = () => {
  const { isMobile } = useIsMobile();

  const [descriptionVisible, toggleDescriptionVisible] = useToggle(!isMobile);

  const categoryName = 'About Smart Bird Feeders';

  const categoryDescription = `
        <p>
        Equipped with motion detection, built-in cameras, and seamless app control, each <strong>bird feeder with camera</strong> lets you monitor and enjoy your backyard visitors anytime, anywhere. Whether you're hoping to capture rare species or simply watch cardinals and chickadees up close, you’ll never miss a moment.
        </p>
        <p>
          Our smart feeders offer HD live streaming, automatic recording, and instant phone alerts, bringing a new level of interaction to backyard birding. Many models include solar power for eco-friendly operation and are built to withstand outdoor elements—perfect for pairing with our <a href="/squirrel-proof-bird-feeders">Squirrel Proof Bird Feeders</a> to keep unwanted guests away, or <a href="/platform-bird-feeders">Platform Bird Feeders</a> for more feeding space and variety.
        </p>
        <p>Looking to attract nesting birds as well? Explore our <a href="/bird-houses">Bird Houses</a> collection to complement your feeding setup and create a complete bird-friendly habitat. With Kingsyard’s smart feeders, birdwatching becomes more immersive, convenient, and enjoyable—anytime, from anywhere.
        </p>
  `;

  const processedHTML = typeof categoryDescription === 'string' ? categoryDescription : String(categoryDescription);

  useEffect(() => {
    if (isMobile) {
      toggleDescriptionVisible();
    }
  }, [isMobile]);

  if (!categoryName || !processedHTML || processedHTML === 'null') {
    return null;
  }

  return (
    <div className={cn('mx-auto my-[60px] w-[1360px] max-w-full px-[15px] lg_px-0')}>
      <div
        className='mb-[18px] flex cursor-pointer select-none items-center justify-center gap-x-2.5 text-center font-poppins font-[600] uppercase leading-[1.4] text-[#615956]'
        onClick={() => {
          toggleDescriptionVisible();
        }}
      >
        <h2>{categoryName}</h2>

        <span className={descriptionVisible ? classes.arrowDown : classes.arrowRight}></span>
      </div>
      {descriptionVisible && (
        <div
          className='font-sans text-sm font-[500] leading-[1.4] text-[#615956]'
          dangerouslySetInnerHTML={{
            __html: processedHTML,
          }}
        />
      )}
    </div>
  );
};

export default Description;
